<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>

      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md='10' :sm='10'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'loanTime')">
              <a-range-picker
                v-model='queryParam.lendingTime'
                format='YYYY-MM-DD'
                style='width: 100%;' />
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'custType')">
              <a-select default-value='' style='width: 120px' v-model='queryParam.custType'>
                <a-select-option value=''>
                  全部
                </a-select-option>
                <a-select-option value='1'>
                  新户
                </a-select-option>
                <a-select-option value='2'>
                  老户
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="'盘号'">
              <a-select
                v-model='queryParam.appssid'
                @change='onChange'
              >
                <a-select-option v-for='item in appList' :key='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md='10' :sm='8'>
            <a-form-item :label="'产品类型'">
              <a-select
                v-model='queryParam.productRiskNo'
                @change='handleChangeproductRiskNo'
                mode='multiple'
              >
                <a-select-option v-for='item in appNameList' :key='item'>
                  {{ item }}
                </a-select-option>
              </a-select>

            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'orderType')">
              <a-select default-value='' style='width: 120px' v-model='queryParam.orderType'>
                <a-select-option value=''>
                  全部
                </a-select-option>
                <a-select-option value='0'>
                  正常订单
                </a-select-option>
                <a-select-option value='1'>
                  展期订单
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t('order.applicationDeadline')">
              <dict-select
                v-model='queryParam.deadlineConfigValue'
                :dict-code='DICT_CODE.Deadline_ConfigValue'
                :begin="[{ value: '', label: '全部', labelEn: 'All',labelTi: 'ทั้งหมด' }]"
                :placeholder="$t('select')"
              />
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item label="前收后收">
              <a-select default-value="" style="width: 120px" v-model="queryParam.receiptTimeFlag">
                <a-select-option value="">
                  全部
                </a-select-option>
                <a-select-option value="0">
                  前收
                </a-select-option>
                <a-select-option value="1">
                  后收
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter='12'>
          <a-col :md='6' :sm='8'>
            <a-form-item label="运营类型">
              <a-select default-value="" style="width: 120px" v-model="queryParam.proxyFlag">
                <a-select-option value="">
                  全部
                </a-select-option>
                <a-select-option value="0">
                  自运营
                </a-select-option>
                <a-select-option value="1">
                  代理运营
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')
                }}</a-button>
              <a-button type='primary' @click="downLoadData('')" icon='download'
                        style='margin-left: 8px'>{{ $t('exportFile')
                }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>


      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered>
      </a-table>


    </div>
    <v-modal
      v-model='visible'
      :title="$t('order.collectionDetail')">
      <div style='padding: 20px;'>
        <collection-detail
          v-if='visible'
          :orderId='orderId'
          :custInfoId='custInfoId'
          :taskId='taskId'
          :auditDrawer='false'
          @close='visible = false;' />
      </div>
    </v-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { countLoanDataWithDateForApp, getApplist,findAllProductRiskNo } from '@/webpublicapi/order'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import exportFile from '@/webpublicapi/exportFile'
import moment from 'moment'
import vModal from '../modules/Modal'
import { getCollectionListDepartment } from '@/webpublicapi/group'
import { getAllDeadlineConfig } from '@/webpublicapi/deadlineConfig'


const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.'
}

export default {
  // name: 'CountCollectionTaskDispense',
  components: {
    Dict,
    DictSelect,
    vModal
  },
  data() {
    return {
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      taskId: undefined,
      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      appList: [],
      appNameList: [],
      // 查询条件
      queryParam: {
        'receiptTimeFlag':'',
        "deadlineConfigValue":'',
        'orderNo': '',
        'appssid': '',
        'mobileNo': '',
        'orderType': '',
        'productRiskNo': [],
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [

        {
          title: this.$t('order.loanDate'),
          align: 'left',
          dataIndex: 'paymentTime'
        },
        {
          title: 'appssid',
          align: 'left',
          dataIndex: 'appSsid'
        },
        {
          title: this.$t('order.appNameValue'),
          align: 'left',
          dataIndex: 'appName'
        },
        {
          title: '产品类型',
          align: 'left',
          dataIndex: 'productRiskNo'
        },
        {
          title: '放款笔数',
          align: 'left',
          dataIndex: 'loanCount'
        },
        {
          title: this.$t('order.loanPensNum'),
          align: 'left',
          dataIndex: 'newLoanCount'
        },
        {
          title: this.$t('order.Newhouseholdpartsareall'),
          align: 'left',
          dataIndex: 'jianjunNew'
        },
        {
          title: this.$t('order.oldAcountsNum'),
          align: 'left',
          dataIndex: 'oldLoanCount'
        },
        {
          title: this.$t('order.Oldhouseholdpartsareall'),
          align: 'left',
          dataIndex: 'jianjunOld'
        },
        {
          title: this.$t('order.ProportionOfOldHouseholds'),
          align: 'left',
          dataIndex: 'noRate'
        },
        {
          title: this.$t('order.loanPrincipal'),
          align: 'left',
          dataIndex: 'paymentAmt'
        },
        {
          title: this.$t('order.NewHouseholdsPrincipalOfl'),
          align: 'left',
          dataIndex: 'newPaymentAmt'
        },
        {
          title: this.$t('order.OldHouseholdsPrincipalOfl'),
          align: 'left',
          dataIndex: 'oldPaymentAmt'
        },
        {
          title: this.$t('order.LoanContractAmount'),
          align: 'left',
          dataIndex: 'applyAmt'
        },
        {
          title: this.$t('order.NewHouseholdContractAmount'),
          align: 'left',
          dataIndex: 'newApplyAmt'
        },
        {
          title: this.$t('order.OldHouseholdContractAmount'),
          align: 'left',
          dataIndex: 'oldApplyAmt'
        }
      ]
    }
  },
  created() {
    this.getDict()
    getApplist().then(res => {
      this.appList = res.data || []
    }),
      //产品名称
      findAllProductRiskNo().then(res => {
        console.log('findAllProductRiskNo', res)
        this.appNameList = res.data || []
      }),
      getAllDeadlineConfig().then(res => {
        this.deadlineConfigList = res.data || []
      }),
      this.loadData()
  },
  methods: {
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    handleChangeproductRiskNo(value) {
      console.log(`Selected: ${value}`)
    },
    searchQuery() {
      this.loadData()
    },
    loadData(arg) {
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      countLoanDataWithDateForApp(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          // this.total = res.data.total
          this.dataSource = res.data || []
          if (this.dataSource.length > 0) {
            for (var i = 0; i < this.dataSource.length; i++) {
              var dataO = this.dataSource[i]

              dataO.jianjunOld = (dataO.oldApplyAmt / dataO.oldLoanCount).toFixed(1)
              dataO.jianjunNew = (dataO.newApplyAmt / dataO.newLoanCount).toFixed(1)

            }
          }
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      const { lendingTime } = this.queryParam
      const data = {
        ...this.queryParam,
        lendingTimeStart: (lendingTime && lendingTime.length) ? this.transformTime(lendingTime[0]) : undefined,
        lendingTimeEnd: (lendingTime && lendingTime.length) ? this.transformTime(lendingTime[1]) : undefined
      }
      delete data.applyDate
      var param = Object.assign({}, data)

      // return filterObj(param)
      return param
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.lendingTime = undefined
      that.queryParam.custType=''
      that.queryParam.appssid=''
      that.queryParam.orderType=''
      that.queryParam.deadlineConfigValue=''
      that.queryParam.receiptTimeFlag = ''
      that.loadData(this.form.pageNum)
    },
    changeModal(visible) {
      this.visible = visible
    },
    downLoadData(arg2) {
      var params = this.getQueryParams(arg2)// 查询条件
      const file = {
        fileUrl: '/api/web/platform/order/countLoanDataWithDateForAppExcel?lendingTimeStart=' + params.lendingTimeStart + '&lendingTimeEnd=' + params.lendingTimeEnd + '&custType=' + params.custType + '&deadlineConfigValue=' + params.deadlineConfigValue,
        fileName: 'countLoanDataWithDateExcel.xls'
      }
      this.loading = true
      exportFile(file).catch(e => {
        this.$message.error(e.message)
      }).finally(() => {
        this.loading = false
      })
    }

  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
